function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.736 4.026c0-1.723 2.014-2.657 3.327-1.542l5.02 4.263.03.03a3.036 3.036 0 010 4.29l-.03.029L17.308 16l5.775 4.904.03.03a3.036 3.036 0 010 4.29l-.03.03-5.02 4.262c-1.313 1.115-3.327.18-3.327-1.542v-9.745l-6.406 5.61L7 22.319 14.212 16 7 9.682 8.33 8.16l6.406 5.611V4.027zm2.02 14.158v9.79l4.952-4.205a1.012 1.012 0 000-1.38l-4.952-4.205zm0-4.368v-9.79l4.952 4.205c.362.388.362.993 0 1.38l-4.952 4.205z",
  fill: "currentColor"
})));